// extracted by mini-css-extract-plugin
export default {"contain":"ServicesHome_contain__QP-Q8","heading":"ServicesHome_heading__CJK24","subHeading":"ServicesHome_subHeading__S2GGX"};